exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sidebar{border-right:4px dotted #ededed;height:calc(100vh - 92px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/home/sidebar/sidebar.scss
// module id = 559
// module chunks = 0